import { useMemo, useState } from 'react'

import { useTheme } from '../../theme/ThemeContext'
import { chromeToolbarButtonClass } from '../ChromeSurface'
import { ThemeModal } from '../modal'
import { IconChevronDown } from '../nav-icons'
import { THEME_SEGMENT_ICONS } from './themeSegmentIcons'
import { ThemeSegmentRail } from './ThemeSegmentRail'

type Props = {
  className?: string
}

/**
 * 移动顶栏 / 登录页窄屏：当前主题 + 展开，完整列表在 {@link ThemeModal} 内。
 */
export function ThemeHeaderPicker({ className = '' }: Props) {
  const { theme, themeOptions } = useTheme()
  const [open, setOpen] = useState(false)
  const angular = theme === 'pixel' || theme === 'geek'
  const CurrentIcon = THEME_SEGMENT_ICONS[theme]
  const currentLabel = useMemo(
    () => themeOptions.find((t) => t.id === theme)?.label ?? '主题',
    [theme, themeOptions],
  )

  const triggerClass = [
    chromeToolbarButtonClass(angular),
    '!gap-1.5 !px-2.5 !py-1.5',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <>
      <button
        type="button"
        className={triggerClass}
        aria-label={`外观主题：${currentLabel}`}
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <CurrentIcon className="h-4 w-4 shrink-0" aria-hidden />
        <span className="text-xs font-semibold">{currentLabel}</span>
        <IconChevronDown className="h-3.5 w-3.5 shrink-0 opacity-75" aria-hidden />
      </button>
      <ThemeModal
        open={open}
        onClose={() => setOpen(false)}
        title="外观主题"
        angular={angular}
        size="sm"
        bodyClassName="px-4 py-4 sm:px-5 sm:py-5"
      >
        <ThemeSegmentRail
          showOptionLabels
          onThemeSelect={() => setOpen(false)}
        />
      </ThemeModal>
    </>
  )
}
